/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  btn: {
    padding: '7px 15px 9px',
    backgroundColor: 'white',
    border: '1px solid',
    color: '#959595',
    fontSize: '16px',
    fontWeight: 500,
    height: '40px',
    marginRight: '16px',
    cursor: 'pointer',
    marginTop: '30px'
  },
  submit: {
    backgroundColor: 'black',
    color: 'white'
  }
});

export default useStyles;
